"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Lob = void 0;
const IonTypes_1 = require("../IonTypes");
const FromJsConstructor_1 = require("./FromJsConstructor");
const Value_1 = require("./Value");
const _fromJsConstructor = new FromJsConstructor_1.FromJsConstructorBuilder()
    .withClasses(Uint8Array)
    .build();
/**
 * This mixin constructs a new class that:
 * - Extends `DomValue`
 * - Extends `Uint8Array`
 * - Has the specified `IonType`.
 *
 * In practice, serves as a common base class for `Blob` and `Clob`.
 *
 * @param ionType   The IonType to associate with the new DomValue subclass.
 * @constructor
 * @private
 */
function Lob(ionType) {
    return class extends (0, Value_1.Value)(Uint8Array, ionType, _fromJsConstructor) {
        constructor(data, annotations = []) {
            super(data);
            this._setAnnotations(annotations);
        }
        uInt8ArrayValue() {
            return this;
        }
        _valueEquals(other, options = {
            epsilon: null,
            ignoreAnnotations: false,
            ignoreTimestampPrecision: false,
            onlyCompareIon: true,
        }) {
            let isSupportedType = false;
            let valueToCompare = null;
            if (options.onlyCompareIon) {
                // `compareOnlyIon` requires that the provided value be an ion.dom.Lob instance.
                if (other.getType() === IonTypes_1.IonTypes.CLOB ||
                    other.getType() === IonTypes_1.IonTypes.BLOB) {
                    isSupportedType = true;
                    valueToCompare = other.uInt8ArrayValue();
                }
            }
            else {
                // We will consider other Lob-ish types
                if (other instanceof Uint8Array) {
                    isSupportedType = true;
                    valueToCompare = other.valueOf();
                }
            }
            if (!isSupportedType) {
                return false;
            }
            let current = this.uInt8ArrayValue();
            let expected = valueToCompare;
            if (current.length !== expected.length) {
                return false;
            }
            for (let i = 0; i < current.length; i++) {
                if (current[i] !== expected[i]) {
                    return false;
                }
            }
            return true;
        }
    };
}
exports.Lob = Lob;
